import React, { Fragment } from 'react';
import Link from 'next/link';

export default function LinkedLabelText({
  labelText,
  url,
  target = '_blank',
}: {
  labelText: string;
  url: string;
  target?: string;
}) {
  const textParts = labelText.split(/%%LINK%%|%%LINK_END%%/).filter((text) => text.length);

  const output = textParts.map((textPart, index) => {
    if (index !== 1) {
      return <Fragment key={index}>{textPart}</Fragment>;
    }
    return (
      <Link href={url} target={target} key={index} data-testid="linked-label-text">
        {textPart}
      </Link>
    );
  });
  return <>{output}</>;
}
